/* Header modelled on planung-frontend's AppHeader.module.scss: a full-width white
 * bar reserving the fixed sidebar via the same static `padding-left` calc, with a
 * `space-between` container. The container is deliberately NOT max-width capped —
 * it must stay flush with the page content (`.container` in DataLoader.module.css),
 * which is uncapped, otherwise the header narrows on wide screens. */
.app-header {
  width: 100%;
  height: var(--header-height);
  background: var(--color-white);
  z-index: var(--z-index-header);
  padding: var(--outer-gutter);
  /* shares the shell's --content-inset so it shifts with the content when the
     sidebar is pinned open (see DataLoader.module.css) */
  padding-left: var(--content-inset, calc(var(--side-gutter) + var(--sidebar-width)));
  transition: padding-left var(--sidebar-easing, 0.3s ease-out);
}

.container {
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 14px;
}

.left {
  flex: 1;
  min-width: 0;
  display: inline-flex;
  align-items: center;
}

.right {
  display: flex;
  align-items: center;
  gap: var(--spacing-2);
}
